/** CRM product: `applicationType` is `scoreboard` with the same calculator-shaped payload. */
export function isScoreboardProductApplicationType(vehicleApplication) {
  return String(vehicleApplication?.applicationType || '').toLowerCase() === 'scoreboard';
}

/** Dashboard bookmark guard: CRM scoreboard product with no shortlists → `/applications`. */
export function isScoreboardProductWithEmptyShortlists(vehicleApplication) {
  return isScoreboardProductApplicationType(vehicleApplication) && (vehicleApplication?.calculator?.shortlists?.length ?? 0) === 0;
}

/**
 * Some GraphQL operations only accept `applicationType: "calculator"`.
 * Vuex still holds `scoreboard`; variables sent to the API use `calculator` for the same journey.
 */
export function applicationTypeForCalculatorApis(vehicleApplication) {
  const t = String(vehicleApplication?.applicationType || '').toLowerCase();
  if (t === 'scoreboard') {
    return 'calculator';
  }
  return vehicleApplication?.applicationType ?? null;
}
